export default __webpack_public_path__ + "static/media/1024px-Edward_Hicks,_American_-_Noah's_Ark_-_Google_Art_Project.89fb46f7.jpg";